import { z } from 'zod';
import { currencyCodeSchema, positiveDecimalSchema } from './common';

/**
 * 🏠 Household auto-split calculator request.
 * Verilen tutar bir household group'unun üyelerine, group'un splitMethod'una
 * göre dağıtılır. Sonuç: { userId, share, percent } array.
 */
export const calculateSplitSchema = z.object({
  amount: positiveDecimalSchema,
  currency: currencyCodeSchema.default('EUR'),
});
export type CalculateSplitInput = z.infer<typeof calculateSplitSchema>;
